import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';

import createRootReducer from 'reducers';
import { history } from 'containers/App';

const store = createStore(
  createRootReducer(history),
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk, routerMiddleware(history))
    : composeWithDevTools(
      applyMiddleware(thunk, routerMiddleware(history))
    )
);

export default store;
